var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    stroke: "#808080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "users"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.75 19.2502V17.4169C2.75 16.4445 3.13631 15.5118 3.82394 14.8242C4.51158 14.1366 5.44421 13.7502 6.41667 13.7502H10.0833C11.0558 13.7502 11.9884 14.1366 12.6761 14.8242C13.3637 15.5118 13.75 16.4445 13.75 17.4169V19.2502M14.6667 2.86942C15.4554 3.07136 16.1545 3.53006 16.6537 4.1732C17.1529 4.81634 17.4239 5.60734 17.4239 6.4215C17.4239 7.23565 17.1529 8.02666 16.6537 8.6698C16.1545 9.31294 15.4554 9.77164 14.6667 9.97358M19.25 19.2503V17.4169C19.2453 16.6077 18.9731 15.8227 18.4757 15.1843C17.9782 14.5459 17.2836 14.0901 16.5 13.8878M4.58333 6.41691C4.58333 7.38937 4.96964 8.322 5.65728 9.00964C6.34491 9.69727 7.27754 10.0836 8.25 10.0836C9.22246 10.0836 10.1551 9.69727 10.8427 9.00964C11.5304 8.322 11.9167 7.38937 11.9167 6.41691C11.9167 5.44445 11.5304 4.51182 10.8427 3.82419C10.1551 3.13655 9.22246 2.75024 8.25 2.75024C7.27754 2.75024 6.34491 3.13655 5.65728 3.82419C4.96964 4.51182 4.58333 5.44445 4.58333 6.41691Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.4f4f7f2a48d5de652ade0b04d1fb3573.svg";
export { ForwardRef as ReactComponent };